import React from 'react';

import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModulePlaceholder} from "../../modules/game-center-header-module/components/placeholders/game-center-header-module.placeholder";
import {MatchWidgetPlaceholder} from "../../../match-widget/components/placeholders/match-widget.placeholder";
import {WithDevice} from "../../../../core/components/composers/with-device";

export class GameCenterWidgetPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const GameCenterWidgetPlaceholder = WithDevice((props: GameCenterWidgetPlaceholderProps) => {
  return (
   <div className={['game-center-widget-placeholder-container', props.device.isSmallView ? 'game-center-widget-placeholder-small-view' : ''].join(' ')}>
     <GameCenterHeaderModulePlaceholder {...props}/>
     <MatchWidgetPlaceholder {...props}/>
   </div>
  )
});
